import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-broadcasting',
  templateUrl: './broadcastings-broadcasting.component.html',
  styleUrls: ['./broadcastings-broadcasting.component.scss']
})
export class BroadcastingsBroadcastingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
